import { handleInvitationLinkCloudFunction } from '@/firebase/init';
import { parseInvitationUrlParams } from '@/utils/invitationUrlParams';
import { useEffect, useRef, useState } from 'react';
import { getAcceptErrorMessage } from './acceptInvitationError';
import { shouldAutoAcceptInvitation } from './invitationLoaderView';
import { useNavigate } from 'react-router-dom';

export function useAcceptInvitation(loaderData: unknown, searchParams: URLSearchParams) {
  const [isAccepting, setIsAccepting] = useState(false);
  const [acceptError, setAcceptError] = useState<string | null>(null);
  const autoAcceptStarted = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (autoAcceptStarted.current) return;
    if (!shouldAutoAcceptInvitation(loaderData)) return;

    autoAcceptStarted.current = true;

    async function runAutoAccept() {
      setIsAccepting(true);
      setAcceptError(null);
      try {
        const parsed = parseInvitationUrlParams(searchParams);
        if (!parsed) {
          throw new Error('Invalid invitation link');
        }
        await handleInvitationLinkCloudFunction({
          hash: parsed.hash,
          invitationType:
            parsed.invitationType === 'organization' ? 'organizations' : 'workspaces',
        });
        navigate('/');
      } catch (error) {
        setAcceptError(getAcceptErrorMessage(error));
        autoAcceptStarted.current = false;
      } finally {
        setIsAccepting(false);
      }
    }

    runAutoAccept();
  }, [loaderData, navigate, searchParams]);

  return { isAccepting, acceptError };
}
